import { ToggleButton as MuiToggleButton, ToggleButtonGroup } from '@mui/material';
import { Component } from 'react';
import { Tooltip } from './Tooltip';

export class ToggleButton extends Component<any, any> {
  static defaultProps = {
    padding: 23,
    title: null,
  };

  render() {
    const { options, onChange, value, disabled, ...props } = this.props;

    return (
      <ToggleButtonGroup
        className={'klayo-togglebutton' + (disabled ? ' klayo-togglebutton--disabled' : '')}
        exclusive
        onChange={onChange}
        value={value}
        disabled={disabled}
        {...props}
      >
        {options.map((option: any) => {
          return (
            <MuiToggleButton
              key={option.value}
              value={option.value}
              disabled={option.disabled}
              disableFocusRipple={true}
              disableRipple={true}
              aria-label='right aligned'
            >
              <Tooltip title={option.tooltip}>{option.icon}</Tooltip>
            </MuiToggleButton>
          );
        })}
      </ToggleButtonGroup>
    );
  }
}
